import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root',
})
export class TaggingGroupService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  private postRequest(endpoint: string, params: string, headers: HttpHeaders): Observable<any> {
    return this._http.post(this.url + endpoint, params, { headers }).pipe(map(res => res as any));
  }

  getTaggingGroups(token: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/list?page=1', params, headers);
  }

  newTagGroup(token: string, group: any): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(group));
    const params = "json=" + json + "&authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/new?page=1', params, headers);
  }

  editTagGroup(token: string, id: string, group: any): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(group));
    const params = "json=" + json + "&authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/edit/' + id + '?page=1', params, headers);
  }

  delete(token: string, id: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/remove/' + id + '?page=1', params, headers);
  }

  detailTagGroups(token: string, id: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/detail/' + id + '?page=1', params, headers);
  }

  listByUser(token: string, id: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.postRequest('/tagginggroup/listbyuser/' + id + '?page=1', params, headers);
  }
}
